import {EligibleChannelsEndpointResponseSuccess} from '@stripe-internal/conversations-shared-dependencies';

export function fetchEligibleChannels(
  supportFetch: typeof fetch,
  entryPoint: string,
  audience: string,
  uhConversationId: string | undefined,
): Promise<EligibleChannelsEndpointResponseSuccess> {
  const params = new URLSearchParams({
    audience,
  });
  if (uhConversationId !== undefined) {
    params.set('uh_conversation_id', uhConversationId);
  }

  return supportFetch(`/api/eligible-channels/${entryPoint}?${params}`).then(
    (resp) => {
      if (resp.ok) {
        return resp.json();
      } else {
        return {channels: []};
      }
    },
  );
}
